export { ErrorContent } from './Error';
export { NewsletterContent } from './Newsletter';
export { CustomContent } from './Custom';
export { useLocalizedLandingPage } from './useLocalizedLandingPage';
export { useDynamicLocalizedLandingPage } from './useDynamicLocalizedLandingPage';

export type { LandingPageProps, PageProps } from './LandingPageProps';
